"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListFilter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var R = __importStar(require("../../../utils/ramda"));
var IncludeExclude_1 = require("../misc/IncludeExclude");
var Wrapper_1 = require("./Wrapper");
var useFilter_1 = require("./useFilter");
var CheckboxList_1 = require("../../../components/CheckboxList");
var Row_1 = require("../../../components/Row");
var TriStateCheckbox_1 = require("../../../components/TriStateCheckbox");
var Input_1 = require("../../../components/Input");
var react_1 = require("react");
var Clickable_1 = require("../../../components/Clickable");
var ListFilter = function (_a) {
  var _b;
  var label = _a.label,
    filterId = _a.id,
    options = _a.options,
    _c = _a.startMode,
    startMode = _c === void 0 ? "include" : _c,
    _d = _a.defaultOptions,
    defaultOptions = _d === void 0 ? [] : _d,
    _e = _a.startExpanded,
    startExpanded = _e === void 0 ? false : _e,
    tooltip = _a.tooltip,
    tooltipIcon = _a.tooltipIcon,
    tooltipColor = _a.tooltipColor,
    tooltipIconColor = _a.tooltipIconColor,
    _f = _a.hideIncludeExclude,
    hideIncludeExclude = _f === void 0 ? false : _f,
    _g = _a.placeholder,
    placeholder = _g === void 0 ? "Enter text" : _g,
    scrollable = _a.scrollable;
  var _h = (0, useFilter_1.useFilter)({
      filterId: filterId,
      defaultMode: startMode,
      defaultOptions: defaultOptions
    }),
    mode = _h.mode,
    optionsSelected = _h.optionsSelected,
    setMode = _h.setMode,
    setSelected = _h.setSelected,
    isActive = _h.isActive,
    isUnsaved = _h.isUnsaved,
    translation = _h.translation;
  var onCheckboxClick = function (id) {
    var index = optionsSelected.findIndex(function (x) {
      return x.id == id;
    });
    if (index === -1) {
      var option = options.find(function (x) {
        return x.id == id;
      });
      var newOptionSelected = R.append(option, optionsSelected);
      setSelected(newOptionSelected);
    } else {
      var newOptionSelected = R.remove(index, 1, optionsSelected);
      setSelected(newOptionSelected);
    }
  };
  var data = options.map(function (option) {
    return {
      label: option.label,
      info: option.info,
      id: option.id,
      state: optionsSelected.some(function (x) {
        return x.id == option.id;
      }) == true ? TriStateCheckbox_1.TriState.Full : TriStateCheckbox_1.TriState.Empty
    };
  });
  var _j = __read((0, react_1.useState)(""), 2),
    search = _j[0],
    setSearch = _j[1];
  var filterActive = search.trim().length;
  var selectFiltered = function (selected) {
    var _text = search.trim().toLowerCase();
    var hasFilter = function (label) {
      return _text.length === 0 || label.toLowerCase().includes(_text);
    };
    var updatedData = options.filter(function (o) {
      return hasFilter(o.label);
    });
    if (selected) {
      var fullData = R.uniqBy(R.prop("id"), __spreadArray(__spreadArray([], __read(updatedData), false), __read(optionsSelected), false));
      setSelected(fullData);
    } else {
      var rejectIds_1 = updatedData.map(function (o) {
        return o.id;
      });
      var fullData = R.reject(function (o) {
        return rejectIds_1.includes(o.id);
      }, optionsSelected);
      setSelected(fullData);
    }
  };
  return (0, jsx_runtime_1.jsxs)(Wrapper_1.FilterWrapper, __assign({
    tooltip: tooltip,
    tooltipIcon: tooltipIcon,
    tooltipColor: tooltipColor,
    tooltipIconColor: tooltipIconColor,
    filterId: filterId,
    label: label,
    mode: mode,
    isActive: isActive,
    isUnsaved: isUnsaved,
    selectedCount: (_b = optionsSelected === null || optionsSelected === void 0 ? void 0 : optionsSelected.length) !== null && _b !== void 0 ? _b : 0,
    startExpanded: startExpanded
  }, {
    children: [!hideIncludeExclude && (0, jsx_runtime_1.jsx)(IncludeExclude_1.IncludeExclude, {
      translation: translation,
      filterId: filterId,
      selectedMode: mode,
      onChange: setMode
    }), (0, jsx_runtime_1.jsx)(Input_1.Input, {
      value: search,
      placeholder: placeholder,
      onChange: function (e) {
        return setSearch(e.currentTarget.value);
      }
    }), (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      justify: "start",
      className: "button-container",
      gap: "large"
    }, {
      children: [(0, jsx_runtime_1.jsx)(Clickable_1.Clickable, __assign({
        type: "secondary",
        onClick: function () {
          return selectFiltered(true);
        }
      }, {
        children: filterActive ? translation.selectVisible : translation.selectAll
      })), (0, jsx_runtime_1.jsx)(Clickable_1.Clickable, __assign({
        type: "secondary",
        onClick: function () {
          return selectFiltered(false);
        }
      }, {
        children: filterActive ? translation.deselectVisible : translation.deselectAll
      }))]
    })), (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-list-filter-container",
      style: !scrollable ? {
        display: "contents"
      } : {}
    }, {
      children: (0, jsx_runtime_1.jsx)(CheckboxList_1.CheckboxList, {
        data: data,
        filter: search,
        onCheckboxClick: onCheckboxClick
      })
    }))]
  }));
};
exports.ListFilter = ListFilter;